import React, { useContext, useEffect } from 'react';
import { EditModeContext } from '../edit-mode';
import { isEventTargetInputElement } from '../utils/is-event-target-input-element';

export const EditModeShortcut: React.FC = () => {
  const { setEditMode } = useContext(EditModeContext);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isEventTargetInputElement(e)) {
        return;
      }

      if (e.metaKey || e.ctrlKey || e.altKey) {
        return;
      }

      switch (e.code) {
        case 'KeyV':
          e.preventDefault();
          setEditMode('select');
          break;
        case 'KeyH':
          e.preventDefault();
          setEditMode('hand');
          break;
        case 'KeyR':
          e.preventDefault();
          setEditMode('draw-solid');
          break;
        case 'KeyB':
          e.preventDefault();
          setEditMode('draw-blur');
          break;
        case 'KeyT':
          e.preventDefault();
          setEditMode('create-text');
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [setEditMode]);

  return null;
};
